export default __webpack_public_path__ + "static/media/screen4.ff965a32.png";